/* SR-041: GearMate add-on tick box behaviour (EU and UK rollout of the NA Intelligems SR-041 V1 win).
 *
 * Built from the NA theme's version for this store. The EU store never ran the Intelligems
 * test, so NA's stand-down for the V1 rollout script is not needed here.
 * The block markup, price and offer variant are rendered server-side by
 * snippets/sr041-gearmate-addon.liquid; this file only adds behaviour:
 *   - the thumbnail opens a lightbox with the pack's image, title and description;
 *   - when the box is ticked, Add to Cart (main button or sticky bar) sends ONE
 *     /cart/add.js request with the pack (quantity 1) listed before the rack line, so a
 *     rejection adds neither; on a rejection with an unchanged cart the rack is added on
 *     its own with a note; when the outcome cannot be confirmed, nothing is re-added.
 */
(function () {
	'use strict';

	var block = document.getElementById('sr041-block');
	if (!block || window.__sr041_theme) return;
	window.__sr041_theme = true;

	var PACK_QTY = 1; // one pack per Add to Cart regardless of rack quantity (V1 rule)
	var LB_ID = 'sr041-lightbox';
	var packId = parseInt(block.getAttribute('data-variant-id'), 10);
	if (!packId) return;

	function checkbox() { return document.getElementById('sr041-check'); }
	function ticked() { var cb = checkbox(); return !!(cb && cb.checked); }

	function visible(el) { return !!el && document.documentElement.contains(el) && el.getBoundingClientRect().height > 0; }

	// The main product form's controls, never the quick view or other forms.
	function findControls() {
		var list = document.querySelectorAll('l-product-controls[id^="Product-Form-Controls-template--"]');
		var i;
		for (i = 0; i < list.length; i++) if (visible(list[i])) return list[i];
		return null;
	}

	// ---------- lightbox ----------
	var lbLastFocus = null, lbPrevOverflow = null, lbCloseBtn = null;

	// Description HTML to plain paragraphs, parsed inertly and rendered with textContent only.
	function descriptionParagraphs(html) {
		if (!html) return [];
		var s = String(html).replace(/<\/(p|div|li|h[1-6]|tr)>/gi, '\n').replace(/<br\s*\/?>/gi, '\n');
		var text = '';
		try {
			var doc = new DOMParser().parseFromString(s, 'text/html');
			text = (doc.body && doc.body.textContent) || '';
		} catch (e) {
			text = s.replace(/<[^>]+>/g, '');
		}
		var parts = text.split('\n'), out = [], i, t;
		for (i = 0; i < parts.length && out.length < 8; i++) {
			t = parts[i].replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
			if (t) out.push(t);
		}
		return out;
	}

	function closeLightbox() {
		var el = document.getElementById(LB_ID);
		if (el && el.parentNode) el.parentNode.removeChild(el);
		document.removeEventListener('keydown', onLightboxKey, true);
		if (lbPrevOverflow !== null) { document.documentElement.style.overflow = lbPrevOverflow; lbPrevOverflow = null; }
		if (lbLastFocus && document.documentElement.contains(lbLastFocus)) { try { lbLastFocus.focus(); } catch (e) {} }
		lbLastFocus = null;
		lbCloseBtn = null;
	}

	function onLightboxKey(e) {
		if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeLightbox(); return; }
		// The dialog's only focusable control is the close button, so Tab stays on it.
		if (e.key === 'Tab' && lbCloseBtn) { e.preventDefault(); try { lbCloseBtn.focus(); } catch (er) {} }
	}

	function openLightbox(fromEl) {
		if (document.getElementById(LB_ID)) return;
		var data = block.querySelector('template.sr041-lb-data');
		var title = (data && data.getAttribute('data-title')) || '';
		var image = (data && data.getAttribute('data-image')) || '';
		var sub = block.querySelector('.sr041-sub');
		lbLastFocus = fromEl || null;

		var wrap = document.createElement('div');
		wrap.id = LB_ID;
		wrap.className = 'sr041-lb';
		wrap.setAttribute('role', 'dialog');
		wrap.setAttribute('aria-modal', 'true');
		wrap.setAttribute('aria-label', title || (block.querySelector('.sr041-title') || {}).textContent || '');

		var backdrop = document.createElement('div');
		backdrop.className = 'sr041-lb__backdrop';
		wrap.appendChild(backdrop);

		var panel = document.createElement('div');
		panel.className = 'sr041-lb__panel';

		var close = document.createElement('button');
		close.type = 'button';
		close.className = 'sr041-lb__close';
		close.setAttribute('aria-label', 'Close');
		close.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
		panel.appendChild(close);
		lbCloseBtn = close;

		if (image) {
			var img = document.createElement('img');
			img.className = 'sr041-lb__img';
			img.src = image;
			img.alt = '';
			panel.appendChild(img);
		}

		var h = document.createElement('h3');
		h.className = 'sr041-lb__title';
		h.textContent = title;
		panel.appendChild(h);

		var body = document.createElement('div');
		body.className = 'sr041-lb__body';
		var paras = descriptionParagraphs(data ? data.innerHTML : ''), i, p;
		if (!paras.length && sub) paras = [sub.textContent];
		for (i = 0; i < paras.length; i++) {
			p = document.createElement('p');
			p.textContent = paras[i];
			body.appendChild(p);
		}
		panel.appendChild(body);
		wrap.appendChild(panel);

		backdrop.addEventListener('click', closeLightbox);
		close.addEventListener('click', closeLightbox);
		document.addEventListener('keydown', onLightboxKey, true);

		lbPrevOverflow = document.documentElement.style.overflow || '';
		document.documentElement.style.overflow = 'hidden';
		document.body.appendChild(wrap);
		try { close.focus(); } catch (e) {}
	}

	document.addEventListener('click', function (e) {
		var t = e.target && e.target.closest ? e.target.closest('[data-sr041-lightbox]') : null;
		if (!t) return;
		e.preventDefault();
		openLightbox(t);
	});

	// ---------- add to cart ----------
	function showNote(text) {
		var old = block.querySelector('.sr041-note');
		if (old) old.parentNode.removeChild(old);
		var n = document.createElement('div');
		n.className = 'sr041-note';
		n.setAttribute('role', 'status');
		n.textContent = text;
		block.appendChild(n);
		setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 6000);
	}

	function submitters(form) {
		var list = [];
		var b = form.querySelector('button[type="submit"]');
		if (b) list.push(b);
		var sticky = document.querySelector('.l-product-sticky-atc__btn');
		if (sticky) list.push(sticky);
		return list;
	}
	function setBusy(form, on) {
		var list = submitters(form), i;
		for (i = 0; i < list.length; i++) {
			if (on) { list[i].classList.add('is-loading'); list[i].setAttribute('data-sr041-busy', '1'); }
			else { list[i].classList.remove('is-loading'); list[i].removeAttribute('data-sr041-busy'); }
		}
	}

	// The rack line carries the cart line fields the form holds: id, quantity, selling plan
	// and properties[...].
	function rackLine(form) {
		var idEl = form.querySelector('[name="id"]');
		if (!idEl || !idEl.value) return null;
		var line = { id: parseInt(idEl.value, 10), quantity: 1 };
		var props = null;
		try {
			var it = new FormData(form).entries(), n, k, v, m;
			while (!(n = it.next()).done) {
				k = n.value[0]; v = n.value[1];
				if (typeof v !== 'string') continue;
				if (k === 'quantity') { var q = parseInt(v, 10); if (q > 0) line.quantity = q; }
				else if (k === 'selling_plan') { if (v) line.selling_plan = v; }
				else { m = /^properties\[(.+)\]$/.exec(k); if (m) { props = props || {}; props[m[1]] = v; } }
			}
		} catch (e) {}
		var qtyEl = form.querySelector('[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + form.id + '"]');
		var q2 = parseInt(qtyEl && qtyEl.value, 10);
		if (q2 > 0) line.quantity = q2;
		if (props) line.properties = props;
		return line;
	}

	// One cart read; resolves to the cart, or null if it could not be read within 6s.
	function readCart() {
		var cc = (typeof AbortController === 'function') ? new AbortController() : null;
		var ct = setTimeout(function () { if (cc) { try { cc.abort(); } catch (e) {} } }, 6000);
		return fetch('/cart.js', { credentials: 'same-origin', signal: cc ? cc.signal : undefined })
			.then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
			.then(function (c) { clearTimeout(ct); return c; }, function () { clearTimeout(ct); return null; });
	}

	function qtyOf(cart, variantId) {
		if (!cart || !cart.items) return null;
		var q = 0, i;
		for (i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === variantId) q += cart.items[i].quantity;
		return q;
	}

	// Same post-add sequence as the theme's product form: cart drawer refresh and open,
	// pub/sub cart update, DOM event.
	function afterAdd(form, rack) {
		try { if (typeof window.getCart === 'function') window.getCart(); } catch (e) {}
		try { if (typeof window.scrollToCartTop === 'function') window.scrollToCartTop(); } catch (e) {}
		try {
			if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
				window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: String(rack.id) });
			}
		} catch (e) {}
		try { document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true, detail: { selector: form.querySelector('button[type="submit"]') } })); } catch (e) {}
	}

	// Resolves to true (both lines confirmed), false (rejected with the cart provably
	// unchanged: safe to add the rack alone) or 'unknown' (never re-add anything).
	function addCombined(form) {
		var rack = rackLine(form);
		if (!rack) return Promise.resolve(false);
		return readCart().then(function (cartBefore) {
			var rackBefore = qtyOf(cartBefore, rack.id);
			var packBefore = qtyOf(cartBefore, packId);
			var controller = (typeof AbortController === 'function') ? new AbortController() : null;
			var timer = setTimeout(function () { if (controller) { try { controller.abort(); } catch (e) {} } }, 8000);
			return fetch('/cart/add.js', {
				method: 'POST', credentials: 'same-origin',
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
				body: JSON.stringify({ items: [{ id: packId, quantity: PACK_QTY }, rack] }),
				signal: controller ? controller.signal : undefined
			}).then(function (r) {
				if (!r.ok) {
					var er = new Error('add failed ' + r.status);
					er.rejected = (r.status === 422 || r.status === 400 || r.status === 404);
					throw er;
				}
				return r.json();
			}).then(function () { clearTimeout(timer); afterAdd(form, rack); return true; })
				.catch(function (err) {
					clearTimeout(timer);
					var rejected = !!(err && err.rejected);
					return readCart().then(function (cartAfter) {
						if (cartBefore === null || cartAfter === null) return 'unknown';
						var rackAfter = qtyOf(cartAfter, rack.id);
						var packAfter = qtyOf(cartAfter, packId);
						if (rackAfter >= rackBefore + rack.quantity && packAfter >= packBefore + PACK_QTY) { afterAdd(form, rack); return true; }
						if (rackAfter !== rackBefore || packAfter !== packBefore) return 'unknown';
						return rejected ? false : 'unknown';
					});
				});
		});
	}

	var submitting = false;
	var bypassOnce = false;

	// Capture phase on document: runs before the theme's own submit handler.
	document.addEventListener('submit', function (e) {
		var form = e.target;
		if (!form || form.tagName !== 'FORM' || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
		var controls = findControls();
		if (!controls || !controls.contains(form)) return;
		if (bypassOnce) { bypassOnce = false; return; }
		if (submitting) { e.preventDefault(); e.stopImmediatePropagation(); return; }
		if (!ticked()) return;
		e.preventDefault();
		e.stopImmediatePropagation();
		submitting = true;
		setBusy(form, true);
		addCombined(form).then(function (ok) {
			setBusy(form, false);
			submitting = false;
			if (ok === true) { var cb = checkbox(); if (cb) cb.checked = false; return; }
			if (ok === 'unknown') {
				showNote('Please check your cart before continuing.');
				try { if (typeof window.getCart === 'function') window.getCart(); } catch (er) {}
				return;
			}
			// Combined add rejected with the cart unchanged (e.g. pack sold out mid-session):
			// the rack goes through alone via the theme's own submit.
			showNote('The pack could not be added. Please add it from your cart.');
			bypassOnce = true;
			try {
				if (typeof form.requestSubmit === 'function') form.requestSubmit();
				else { var b = form.querySelector('button[type="submit"]'); if (b) b.click(); }
			} catch (er) { bypassOnce = false; }
		});
	}, true);

	// Block a second tap on any submitter (the sticky bar button sits outside the form)
	// while the combined request is in flight.
	document.addEventListener('click', function (e) {
		var t = e.target && e.target.closest ? e.target.closest('[data-sr041-busy]') : null;
		if (t && submitting) { e.preventDefault(); e.stopImmediatePropagation(); }
	}, true);
})();
